import {
  AnyAction,
  combineReducers,
  configureStore,
  createAction
} from '@reduxjs/toolkit'
import settingsApiReducer from './api/settings-api-slice'
import returnsApiReducer from './api/returns-api-slice'
import orderReducer from './order/order-slice'
import returnReducer from './return/return-slice'
import returnMethodsApiReducer from './api/return-methods-api-slice'
import refundMethodsApiSlice from './api/refund-methods-api-slice'
import storeApiSlice from './api/store-api-slice'

const appReducer = combineReducers({
  settingsApi: settingsApiReducer,
  returnsApi: returnsApiReducer,
  returnMethodsApi: returnMethodsApiReducer,
  refundMethodsApi: refundMethodsApiSlice,
  order: orderReducer,
  return: returnReducer,
  store: storeApiSlice
})

export const resetStore = createAction('reset/store')

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction
) => {
  if (action.type === resetStore.type) {
    return appReducer(
      { settingsApi: state?.settingsApi } as ReturnType<typeof appReducer>,
      action
    )
  }

  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }),
  devTools: import.meta.env.DEV
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
